import { px2em } from 'ksk/styledComponents/functions';
import { kskTheme } from 'ksk/styledComponents/themes';
import styled from 'styled-components';

export const Div = styled.div.attrs(({ className }) => ({
  className: `ksk-button-container d-sm-inline-flex ${className || ''}`
}))`
  &--swap-colors {
    &.ksk-button--primary {
      color: ${kskTheme.primaryColor};
      background-color: ${kskTheme.textOverPrimaryColor};
    }

    &.ksk-button--warn {
      color: ${kskTheme.warnColor};
      background-color: ${kskTheme.textOverWarnColor};
    }

    &.ksk-button--danger {
      color: ${kskTheme.dangerColor};
      background-color: ${kskTheme.textOverDangerColor};
    }

    &.ksk-button--info {
      color: ${kskTheme.infoColor};
      background-color: ${kskTheme.textOverInfoColor};
    }
  }

  &--small, &--alert {
    font-size: .8em;
    padding: 0 .65em 0 .75em;
    margin: 0;
    min-width: ${px2em(50)};
    line-height: 1;
    min-height: 2em;

    > .ksk-button__icon {
      width: 2.15em;
    }
  }

  &--mini {
    font-size: .8em;
    padding: 0 .65em 0 .75em;
    margin: 0;
    min-width: ${px2em(50)};
    line-height: 1;
    min-height: 1.75em;

    > .ksk-button__icon {
      width: 2.15em;
    }
  }

  &--large {
    font-size: 1.2em;
  }
  
  &.ksk-button--small.ksk-button--with-icon {
    padding-left: 2.5em;
  }

  &.ksk-button.ksk-button--mini.ksk-button--with-icon {
    padding-left: 2.5em;
  }

  &.ksk-button--small.ksk-button--with-icon-right {
    padding-right: 2.5em;
  }

  &.ksk-button.ksk-button--mini.ksk-button--with-icon-right {
    padding-right: 2.5em;
  }

  > .ksk-button__effect {
    content: 's';
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    background-color: red;
    box-shadow: none;
    width: 1px;
    height: 1px;
    color: transparent;
  }
  
  > .ksk-button__effect {
    content: 's';
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    background-color: red;
    box-shadow: none;
    width: 1px;
    height: 1px;
    color: transparent;
  }

  .ksk-button__effect {
    content: 's';
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    background-color: red;
    box-shadow: none;
    width: 1px;
    height: 1px;
    color: transparent;
  }

  .ksk-button__error-disclaimer {
    position: absolute;
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-column-gap: .35em;
    background: ${kskTheme.dangerColor};
    color: ${kskTheme.textOverDangerColor};
    bottom: -.95em;
    white-space: nowrap;
    font-size: ${px2em(11)};
    padding: .35em .5em;
    border-radius: ${kskTheme.borderRadius};
    align-items: center;
    line-height: 1;
  }

  .ksk-button__float-icon {
    position: absolute;
    transform: scale(.65);

    &--top-left {
      top: -0.6em;
      left: -0.6em;
    }

    &--top-right {
      top: -0.6em;
      right: -0.6em;
    }

    &--bottom-right {
      bottom: -0.6em;
      right: -0.6em;
    }

    &--bottom-left {
      bottom: -0.6em;
      left: -0.6em;
    }
  }
`;

export const S = {
  Div
}
